import React, { FC, useMemo } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { BANNER_TYPE, Banner } from "@lookiero/aurora";
import { useI18nMessage } from "@lookiero/i18n-react";
import { useStaticInfo } from "../../hooks/useStaticInfo";
import { DOMAIN, I18nMessages } from "../../i18n/i18n";

interface CrossSellingBannerProps {
  readonly style?: StyleProp<ViewStyle>;
  readonly onPress: () => void;
}

const CrossSellingBanner: FC<CrossSellingBannerProps> = ({ style: customStyle, onPress }) => {
  const { cdnPath } = useStaticInfo();

  const footerCrossSellingBannerDescriptionText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.FOOTER_CROSSELLING_BANNER_DESCRIPTION,
  });
  const footerCrossSellingBannerTitleText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.FOOTER_CROSSELLING_BANNER_TITLE,
  });
  const footerCrossSellingBannerCtaText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.FOOTER_CROSSELLING_BANNER_CTA,
  });

  const bannerImageUrl = useMemo(() => `${cdnPath}/images/shop/banners/box/desktop.webp`, [cdnPath]);

  return (
    <Banner
      description={footerCrossSellingBannerDescriptionText}
      image={{ src: bannerImageUrl }}
      style={customStyle}
      title={footerCrossSellingBannerTitleText}
      type={BANNER_TYPE.ROUNDED}
      primaryButton={{
        text: footerCrossSellingBannerCtaText,
        onPress,
      }}
      scaled
    />
  );
};

export { CrossSellingBanner };
